import React from 'react';
import { AppBar, Toolbar, Typography, IconButton, Container, Avatar, Button, Box, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Logo from "../../assets/logo.jpg";
import "../App.css";

const AdminAppbar = ({ handleDrawerOpen, isMobile = true }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleLogout = () => {
    localStorage.removeItem("care_admin_token");
    navigate("/admin/login");
  };

  return (
    <AppBar className="admin-header" position="fixed" sx={{ bgcolor: "#00C261", zIndex: 1100 }}>
      <Container>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {isMobile && (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerOpen}
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
            )}
            <Avatar alt="Company Logo" src={Logo} sx={{ marginRight: 2 }} />
            {!isSmallScreen && (
              <Typography variant="h6" component="div">
                Bevogtet Admin
              </Typography>
            )}
          </Box>
          <Box
            className="notification-container"
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            {!isSmallScreen && (
              <Typography variant="subtitle1" sx={{ marginRight: 2 }}>
                Welcome, Admin
              </Typography>
            )}
            <IconButton color="inherit" aria-label="notifications">
              <NotificationsIcon />
            </IconButton>
            <Button color="inherit" onClick={handleLogout}>Logout</Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default AdminAppbar;
